function DropDown(props) {
    return (
        <div>
            <label
                htmlFor={props.id}
                className={`block text-sm font-medium text-gray-700 mb-1 ${props.invalid && 'text-red-500'}`}
            >
                {props.label}{" "}
                {!props.optional && <span className="text-red-500">*</span>}
            </label>

            <select
                id={props.id}
                name={props.name}
                onClick={props.onClick}
                value={props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
                onFocus={props.onFocus}
                required={props.required}
                disabled={props.disabled}
                className={`w-full px-4 py-2 border-1 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${props.invalid && "p-invalid"
                    }`}
            >
                <option value="">{props.placeholder || "Selecione uma opção"}</option>
                {props.options &&
                    props.options.map((option) => (
                        <option key={option[props.optionValue]} value={option[props.optionValue]}>
                            {option[props.optionLabel]} {option[props.optionLabel2] && ' - ' + option[props.optionLabel2]}
                        </option>
                    ))}
            </select>
        </div>
    );
}

export default DropDown;
